import { EMessengerAppName, IMessengerAppParamsByName, MessengerEventBus } from '@xometry/ui';

/* v8 ignore start -- enum declaration: no logic to cover */
export enum ESide {
  Right = 'right',
  Left = 'left',
}
/* v8 ignore stop */

/* v8 ignore start -- enum declaration: no logic to cover */
export enum EOverlayType {
  Messenger = 'messenger',
  None = 'none',
}
/* v8 ignore stop */

export type TOverlayContainerContextParam =
  | ({
      type: EOverlayType.Messenger;
    } & IMessengerAppParamsByName[EMessengerAppName.PARTNERS_MAIN])
  | {
      type: EOverlayType.None;
    };

export interface IOverlayContainerContext {
  context: TOverlayContainerContextParam;
  side?: ESide;
  openSideOverlay: (context: TOverlayContainerContextParam) => void;
  closeSideOverlay: () => void;
  toggleSide?: () => void;
  eventBus?: MessengerEventBus;
  setEventBus: (eventBus: IOverlayContainerContext['eventBus']) => void;
  hasBeenInitialized: boolean;
}
